module.exports = __webpack_public_path__ + "img/line-graph.20a4a2d9.svg";